import { useMutation } from "@tanstack/react-query";
import {
  getCalendarNominalDays,
  postCalendar,
  postExceptionDay,
  updateNominalDay
} from "PFCore/services/booking_config";
import { ExceptionDay, NominalDay } from "PFTypes/booking/booking_config";
import { MutationOptions } from "PFTypes/request_options";

type UseCreateCalendar = {
  options?: MutationOptions<CreateCalendarData>;
};

type CreateCalendarData = {
  calendarName: string;
  nominalDays: NominalDay[];
  exceptionDays: ExceptionDay[];
  main: boolean;
};

export const useCreateCalendar = ({ options }: UseCreateCalendar) =>
  useMutation({
    mutationFn: async ({ calendarName, main, nominalDays, exceptionDays }: CreateCalendarData) => {
      const { id: calendarId } = await postCalendar(calendarName, main);
      const { entries: remoteNominalDays } = await getCalendarNominalDays(String(calendarId));
      await Promise.all(
        nominalDays.map((nominalDay) => {
          updateNominalDay({
            ...nominalDay,
            calendarId,
            id: (remoteNominalDays as NominalDay[]).find(({ dayName }) => dayName === nominalDay.dayName)?.id
          });
        })
      );
      await Promise.all(
        exceptionDays.map((exceptionDay) => postExceptionDay({ ...exceptionDay, calendarId }))
      );
      return calendarId;
    },
    ...options
  });
